import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=3b71335a&scoped=true&"
import script from "./AddPartner.vue?vue&type=script&lang=js&"
export * from "./AddPartner.vue?vue&type=script&lang=js&"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=3b71335a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71335a",
  null
  
)

export default component.exports